import type { ResourceAttribution } from "@/types_api/backend/transport/get_metric_response"

/** Canonical nulls never fall back to historical display labels. */
export function resourceHeaderAttribution(
  attribution: ResourceAttribution | null | undefined,
  {
    resolveCreator,
    error,
    retry,
  }: {
    resolveCreator: (userId: string | null | undefined) => string
    error: Error | null
    retry: () => Promise<unknown>
  },
) {
  if (!attribution) {
    return undefined
  }
  return {
    onRetry:
      error && (attribution.created_by || attribution.updated_by)
        ? () => {
            void retry()
          }
        : undefined,
    createdAt: attribution.created_at,
    createdBy: resourceCreatorLabel(attribution, resolveCreator) || undefined,
    updatedAt: attribution.updated_at,
    updatedBy:
      attribution.updated_by !== undefined ||
      attribution.updated_at !== undefined
        ? resolveCreator(attribution.updated_by)
        : undefined,
  }
}

/** Absent canonical metadata stays empty; a canonical null actor uses the resolver's placeholder. */
export function resourceCreatorLabel(
  attribution: ResourceAttribution | null | undefined,
  resolveCreator: (userId: string | null | undefined) => string,
): string {
  return attribution &&
    (attribution.created_by !== undefined ||
      attribution.created_at !== undefined)
    ? resolveCreator(attribution.created_by)
    : ""
}
